/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AssignMissingIndividualIncentive } from '@coin/shared/core/util-models-v2';
import { BucketComponentModificationResponse } from '@coin/shared/core/util-models-v2';
import { BucketComponentsPossibilities } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModel } from '@coin/shared/core/util-models-v2';
import { BudgetBucketModificationResponse } from '@coin/shared/core/util-models-v2';
import { CalculateManySimulations } from '@coin/shared/core/util-models-v2';
import { CalculateSimulation } from '@coin/shared/core/util-models-v2';
import { CandidatePoolModel } from '@coin/shared/core/util-models-v2';
import { ChangeManyPriorities } from '@coin/shared/core/util-models-v2';
import { CreateBucketComponent } from '@coin/shared/core/util-models-v2';
import { CreateCandidatePool } from '@coin/shared/core/util-models-v2';
import { CreateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { CreateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { CreateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { CreateMember } from '@coin/shared/core/util-models-v2';
import { CreateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { CreatePlan } from '@coin/shared/core/util-models-v2';
import { CreatePlanSettings } from '@coin/shared/core/util-models-v2';
import { CreatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { CreateSeason } from '@coin/shared/core/util-models-v2';
import { DuplicateIncentiveSeason } from '@coin/shared/core/util-models-v2';
import { EmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { EmployeeSeasonOverview } from '@coin/shared/core/util-models-v2';
import { EmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { ExportEmployeePopulationResultDto } from '@coin/shared/core/util-models-v2';
import { MemberModel } from '@coin/shared/core/util-models-v2';
import { MeritCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { MeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models-v2';
import { OrganisationInformationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotModel } from '@coin/shared/core/util-models-v2';
import { OrganisationSnapshotTreeItem } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeeSnapshotsEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfEmployeesEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfMember } from '@coin/shared/core/util-models-v2';
import { PageOfMeritInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfOrganisationSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfPlan } from '@coin/shared/core/util-models-v2';
import { PageOfPlanWithMissingIndividualValues } from '@coin/shared/core/util-models-v2';
import { PageOfPositionEvaluationCandidate } from '@coin/shared/core/util-models-v2';
import { PageOfRecord } from '@coin/shared/core/util-models-v2';
import { PageOfSeason } from '@coin/shared/core/util-models-v2';
import { PageOfSnapshot } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PlanModel } from '@coin/shared/core/util-models-v2';
import { PlanSettingsModel } from '@coin/shared/core/util-models-v2';
import { PopulationCreatedResultPagedDto } from '@coin/shared/core/util-models-v2';
import { PositionEvaluationSimulationModel } from '@coin/shared/core/util-models-v2';
import { PublicationSettingsModel } from '@coin/shared/core/util-models-v2';
import { RecordModel } from '@coin/shared/core/util-models-v2';
import { RuleSet } from '@coin/shared/core/util-models-v2';
import { SeasonModel } from '@coin/shared/core/util-models-v2';
import { SeasonSettingsModel } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsCreateSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsSimulation } from '@coin/shared/core/util-models-v2';
import { SeasonsSimulationsUpdateSimulation } from '@coin/shared/core/util-models-v2';
import { SetSeasonSettings } from '@coin/shared/core/util-models-v2';
import { SimulationPublicationsPublishSimulation } from '@coin/shared/core/util-models-v2';
import { Snapshot } from '@coin/shared/core/util-models-v2';
import { StatusResponse } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models-v2';
import { UnPublishSimulation } from '@coin/shared/core/util-models-v2';
import { UpdateBucketComponent } from '@coin/shared/core/util-models-v2';
import { UpdateBudgetBucket } from '@coin/shared/core/util-models-v2';
import { UpdateCandidatePool } from '@coin/shared/core/util-models-v2';
import { UpdateCommunicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshotPartial } from '@coin/shared/core/util-models-v2';
import { UpdateInformationVisibilitySettings } from '@coin/shared/core/util-models-v2';
import { UpdateManyBucketComponents } from '@coin/shared/core/util-models-v2';
import { UpdateManyBudgetBuckets } from '@coin/shared/core/util-models-v2';
import { UpdateMember } from '@coin/shared/core/util-models-v2';
import { UpdateOrganisationInformationSnapshot } from '@coin/shared/core/util-models-v2';
import { UpdatePlan } from '@coin/shared/core/util-models-v2';
import { UpdatePlanSettings } from '@coin/shared/core/util-models-v2';
import { UpdatePublicationSettings } from '@coin/shared/core/util-models-v2';
import { UpdateSeason } from '@coin/shared/core/util-models-v2';
import { UpdateSimulationMembers } from '@coin/shared/core/util-models-v2';
import { UpdateSnapshotBenchmarkValues } from '@coin/shared/core/util-models-v2';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface AssignKpiDetailsToRecordRecordsParams {
  recordId: string;
  /** Information about the record and kpis */
  assignMissingIndividualIncentive?: AssignMissingIndividualIncentive;
}

export interface SeasonsIncentiveAdminCalculateManySimulationParams {
  seasonId: string;
  calculateManySimulations?: CalculateManySimulations;
}

export interface SeasonsIncentiveAdminCalculateSimulationParams {
  seasonId: string;
  calculateSimulation?: CalculateSimulation;
}

export interface SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams {
  simulationId: string;
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsIncentiveAdminChangePrioritiesPlansParams {
  changeManyPriorities?: ChangeManyPriorities;
}

export interface SeasonsIncentiveAdminCreateBudgetComponentsParams {
  budgetBucketId: string;
  createBucketComponent?: CreateBucketComponent;
}

export interface SeasonsIncentiveAdminCreateCandidatePoolsParams {
  createCandidatePool?: CreateCandidatePool;
}

export interface SeasonsIncentiveAdminCreateEmployeeSnapshotsParams {
  createEmployeeSnapshot?: CreateEmployeeSnapshot;
}

export interface SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams {
  simulationId: string;
  createInformationVisibilitySettings?: CreateInformationVisibilitySettings;
}

export interface SeasonsIncentiveAdminCreateManyBudgetComponentsParams {
  budgetBucketId: string;
  createManyBucketComponents?: CreateManyBucketComponents;
}

export interface SeasonsIncentiveAdminCreateMembersParams {
  createMember?: CreateMember;
}

export interface SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams {
  seasonId: string;
  createOrganisationInformationSnapshot?: CreateOrganisationInformationSnapshot;
}

export interface SeasonsIncentiveAdminCreatePlanSettingsParams {
  planId: string;
  createPlanSettings?: CreatePlanSettings;
}

export interface SeasonsIncentiveAdminCreatePlansParams {
  createPlan?: CreatePlan;
}

export interface SeasonsIncentiveAdminCreatePublicationSettingsParams {
  seasonId: string;
  createPublicationSettings?: CreatePublicationSettings;
}

export interface SeasonsIncentiveAdminCreateSeasonsParams {
  createSeason?: CreateSeason;
}

export interface SeasonsIncentiveAdminCreateSimulationParams {
  seasonsSimulationsCreateSimulation?: SeasonsSimulationsCreateSimulation;
}

export interface SeasonsIncentiveAdminDeleteBudgetComponentsParams {
  budgetBucketId: string;
}

export interface SeasonsIncentiveAdminDeleteCandidatePoolsParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminDeleteMembersParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminDeletePlanSettingsParams {
  id: string;
  planId: string;
}

export interface SeasonsIncentiveAdminDeletePlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteSeasonsParams {
  id: string;
}

export interface SeasonsIncentiveAdminDeleteSimulationSettingsParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminDuplicateSeasonsParams {
  id: string;
  duplicateIncentiveSeason?: DuplicateIncentiveSeason;
}

export interface SeasonsIncentiveAdminExportEmployeeCandidatesParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  fileName?: string;
}

export interface SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminExportSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetBudgetBucketsParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetBudgetBucketsPlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetByIdRecordsParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsIncentiveAdminGetEmployeeSnapshotsParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: Array<string>;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetMembersParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetOrganisationSnapshotsParams {
  seasonId: string;
  id: string;
}

export interface SeasonsIncentiveAdminGetPlanPopulationPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetPlanRecordsPlansParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminGetPlanSettingsParams {
  planId: string;
}

export interface SeasonsIncentiveAdminGetPlansParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetPublicationSettingsParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetRecordsParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams {
  gid?: string;
}

export interface SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams {
  id: string;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminGetSeasonSettingsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminGetSeasonsParams {
  id: string;
}

export interface SeasonsIncentiveAdminGetSimulationParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminGetSnapshotSeasonsParams {
  id: string;
  employeeId: string;
}

export interface SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams {
  snapshotId: string;
  updateEmployeeSnapshotPartial?: UpdateEmployeeSnapshotPartial;
}

export interface SeasonsIncentiveAdminPrePublishSimulationPublicationsParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsIncentiveAdminPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  simulationPublicationsPublishSimulation?: SimulationPublicationsPublishSimulation;
}

export interface SeasonsIncentiveAdminQueryCandidatePoolsParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminQueryEmployeeCandidatesParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsIncentiveAdminQueryEmployeeSnapshotsParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryFieldValuesRecordsParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryMembersParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminQueryOrganisationSnapshotsParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: Array<string>;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams {
  seasonId: string;
  seasonId2: string;
  queryOrgCode?: string;
}

export interface SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminQueryPlansParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsIncentiveAdminQuerySeasonsParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsIncentiveAdminQuerySimulationParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminRecalculatePlanPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility'
    | 'Incentive'
    | 'NewHireIncentive'
    | 'IncentiveSub'
    | 'NewHireIncentiveSub';
}

export interface SeasonsIncentiveAdminSavePlanPopulationsParams {
  id: string;
}

export interface SeasonsIncentiveAdminSaveSeasonPopulationsParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminSimulatePlanPopulationsParams {
  id: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminSimulateSeasonPopulationsParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  ruleSet?: RuleSet;
}

export interface SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminUnPublishSimulationPublicationsParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  unPublishSimulation?: UnPublishSimulation;
}

export interface SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams {
  updateSnapshotBenchmarkValues?: UpdateSnapshotBenchmarkValues;
}

export interface SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams {
  budgetBucketId: string;
  updateManyBucketComponents?: UpdateManyBucketComponents;
}

export interface SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams {
  budgetBucketId: string;
  updateBucketComponent?: UpdateBucketComponent;
}

export interface SeasonsIncentiveAdminUpdateBudgetBucketsParams {
  id: string;
  updateBudgetBucket?: UpdateBudgetBucket;
}

export interface SeasonsIncentiveAdminUpdateCandidatePoolsParams {
  id: string;
  updateCandidatePool?: UpdateCandidatePool;
}

export interface SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams {
  updateEmployeeSnapshot?: UpdateEmployeeSnapshot;
}

export interface SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams {
  settingsId: string;
  simulationId: string;
  updateInformationVisibilitySettings?: UpdateInformationVisibilitySettings;
}

export interface SeasonsIncentiveAdminUpdateManyBudgetBucketsParams {
  updateManyBudgetBuckets?: UpdateManyBudgetBuckets;
}

export interface SeasonsIncentiveAdminUpdateMembersParams {
  updateMember?: UpdateMember;
}

export interface SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams {
  seasonId: string;
  id: string;
  updateOrganisationInformationSnapshot?: UpdateOrganisationInformationSnapshot;
}

export interface SeasonsIncentiveAdminUpdatePlanSettingsParams {
  id: string;
  planId: string;
  updatePlanSettings?: UpdatePlanSettings;
}

export interface SeasonsIncentiveAdminUpdatePlansParams {
  id: string;
  updatePlan?: UpdatePlan;
}

export interface SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams {
  seasonId: string;
  updatePublicationSettings?: UpdatePublicationSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams {
  seasonId: string;
  updateCommunicationSettings?: UpdateCommunicationSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonSettingsParams {
  setSeasonSettings?: SetSeasonSettings;
}

export interface SeasonsIncentiveAdminUpdateSeasonsParams {
  updateSeason?: UpdateSeason;
}

export interface SeasonsIncentiveAdminUpdateSimulationParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulation?: SeasonsSimulationsUpdateSimulation;
}

export interface SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams {
  seasonId: string;
  simulationId: string;
  updateSimulationMembers?: UpdateSimulationMembers;
}

@Injectable({
  providedIn: 'root'
})
export class SeasonsIncentiveAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Assigns a Kpi Detail to given Record
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: AssignKpiDetailsToRecordRecordsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    if (recordId === null || recordId === undefined) {
      throw new Error(
        'Required parameter recordId was null or undefined when calling assignKpiDetailsToRecordRecords.'
      );
    }
    const assignMissingIndividualIncentive = requestParameters?.assignMissingIndividualIncentive;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/individual-values`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: assignMissingIndividualIncentive,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCalculationStatus>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public seasonsIncentiveAdminCalculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateManySimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminCalculateManySimulation.'
      );
    }
    const calculateManySimulations = requestParameters?.calculateManySimulations;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`;
    return this.httpClient.request<TransactionStatusOfCalculationStatus>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: calculateManySimulations,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public seasonsIncentiveAdminCalculateSimulation(
    requestParameters?: SeasonsIncentiveAdminCalculateSimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminCalculateSimulation.'
      );
    }
    const calculateSimulation = requestParameters?.calculateSimulation;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`;
    return this.httpClient.request<TransactionStatusOfMassSimulationCalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: calculateSimulation,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<StatusResponse>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<StatusResponse>>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<StatusResponse>>;
  public seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesInformationVisibilitySettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminChangePrioritiesInformationVisibilitySettings.'
      );
    }
    const changeManyPriorities = requestParameters?.changeManyPriorities;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`;
    return this.httpClient.request<StatusResponse>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: changeManyPriorities,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminChangePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminChangePrioritiesPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const changeManyPriorities = requestParameters?.changeManyPriorities;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/priorities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: changeManyPriorities,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateBudgetComponentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling seasonsIncentiveAdminCreateBudgetComponents.'
      );
    }
    const createBucketComponent = requestParameters?.createBucketComponent;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<BucketComponentModificationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: createBucketComponent,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<CandidatePoolModel>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsIncentiveAdminCreateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminCreateCandidatePoolsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createCandidatePool = requestParameters?.createCandidatePool;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools`;
    return this.httpClient.request<CandidatePoolModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createCandidatePool,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminCreateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createEmployeeSnapshot = requestParameters?.createEmployeeSnapshot;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<EmployeeSnapshotsEmployeeSnapshot>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: createEmployeeSnapshot,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminCreateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminCreateInformationVisibilitySettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminCreateInformationVisibilitySettings.'
      );
    }
    const createInformationVisibilitySettings = requestParameters?.createInformationVisibilitySettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<MeritInformationVisibilitySettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: createInformationVisibilitySettings,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminCreateManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminCreateManyBudgetComponentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling seasonsIncentiveAdminCreateManyBudgetComponents.'
      );
    }
    const createManyBucketComponents = requestParameters?.createManyBucketComponents;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<BucketComponentModificationResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: createManyBucketComponents,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminCreateMembers(
    requestParameters?: SeasonsIncentiveAdminCreateMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createMember = requestParameters?.createMember;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<MemberModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createMember,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminCreateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminCreateOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminCreateOrganisationInformationSnapshots.'
      );
    }
    const createOrganisationInformationSnapshot = requestParameters?.createOrganisationInformationSnapshot;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<OrganisationInformationSnapshotModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: createOrganisationInformationSnapshot,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminCreatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePlanSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error(
        'Required parameter planId was null or undefined when calling seasonsIncentiveAdminCreatePlanSettings.'
      );
    }
    const createPlanSettings = requestParameters?.createPlanSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<PlanSettingsModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPlanSettings,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminCreatePlans(
    requestParameters?: SeasonsIncentiveAdminCreatePlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createPlan = requestParameters?.createPlan;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans`;
    return this.httpClient.request<PlanModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPlan,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminCreatePublicationSettings(
    requestParameters?: SeasonsIncentiveAdminCreatePublicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminCreatePublicationSettings.'
      );
    }
    const createPublicationSettings = requestParameters?.createPublicationSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<PublicationSettingsModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createPublicationSettings,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminCreateSeasons(
    requestParameters?: SeasonsIncentiveAdminCreateSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const createSeason = requestParameters?.createSeason;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<SeasonModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createSeason,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminCreateSimulation(
    requestParameters?: SeasonsIncentiveAdminCreateSimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSimulationsCreateSimulation = requestParameters?.seasonsSimulationsCreateSimulation;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCreateSimulation,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminDeleteBudgetComponentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling seasonsIncentiveAdminDeleteBudgetComponents.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminDeleteCandidatePoolsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminDeleteCandidatePools.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error(
        'Required parameter snapshotId was null or undefined when calling seasonsIncentiveAdminDeleteEmployeeSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteMembers(
    requestParameters?: SeasonsIncentiveAdminDeleteMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminDeleteMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public seasonsIncentiveAdminDeleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminDeleteOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminDeleteOrganisationInformationSnapshots.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminDeleteOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<boolean>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminDeletePlanSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminDeletePlanSettings.'
      );
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error(
        'Required parameter planId was null or undefined when calling seasonsIncentiveAdminDeletePlanSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeletePlans(
    requestParameters?: SeasonsIncentiveAdminDeletePlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminDeletePlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteSeasons(
    requestParameters?: SeasonsIncentiveAdminDeleteSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminDeleteSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public seasonsIncentiveAdminDeleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminDeleteSimulationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminDeleteSimulationSettings.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminDeleteSimulationSettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminDeleteSimulationSettings.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public seasonsIncentiveAdminDuplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminDuplicateSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminDuplicateSeasons.'
      );
    }
    const duplicateIncentiveSeason = requestParameters?.duplicateIncentiveSeason;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: duplicateIncentiveSeason,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminExportEmployeeCandidatesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminExportEmployeeCandidates.'
      );
    }
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const recordIds = requestParameters?.recordIds;
    const state = requestParameters?.state;
    const filename = requestParameters?.filename;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (recordIds) {
      recordIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RecordIds');
      });
    }
    if (state !== undefined && state !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>state, 'State');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminExportOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminExportOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const fileName = requestParameters?.fileName;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (fileName !== undefined && fileName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fileName, 'fileName');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public seasonsIncentiveAdminExportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminExportPlanWithMissingIndividualValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/missing-individual-values`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<ExportEmployeePopulationResultDto>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<ExportEmployeePopulationResultDto>>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<ExportEmployeePopulationResultDto>>;
  public seasonsIncentiveAdminExportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminExportSeasonPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminExportSeasonPopulations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`;
    return this.httpClient.request<ExportEmployeePopulationResultDto>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BudgetBucketModel>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetBudgetBuckets.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<BudgetBucketModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<BudgetBucketModel>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<BudgetBucketModel>>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<BudgetBucketModel>>>;
  public seasonsIncentiveAdminGetBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminGetBudgetBucketsPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetBudgetBucketsPlans.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`;
    return this.httpClient.request<Array<BudgetBucketModel>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<RecordModel>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<RecordModel>>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<RecordModel>>;
  public seasonsIncentiveAdminGetByIdRecords(
    requestParameters?: SeasonsIncentiveAdminGetByIdRecordsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    if (recordId === null || recordId === undefined) {
      throw new Error(
        'Required parameter recordId was null or undefined when calling seasonsIncentiveAdminGetByIdRecords.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<RecordModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminGetEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error(
        'Required parameter snapshotId was null or undefined when calling seasonsIncentiveAdminGetEmployeeSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeeSnapshotsEmployeeSnapshot>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetInformationFieldValuesOrganisationInformationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminGetMembers(
    requestParameters?: SeasonsIncentiveAdminGetMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminGetMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<MemberModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetMySeasonRecordsSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetMySeasonRecordsSeasons.'
      );
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'memberId');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`;
    return this.httpClient.request<PageOfRecord>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetOfSeasonPublicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetOfSeasonPublicationSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<PublicationSettingsModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetOrganisationInformationSnapshots.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<OrganisationInformationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<OrganisationSnapshotModel>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminGetOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetOrganisationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetOrganisationSnapshots.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetOrganisationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<OrganisationSnapshotModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfMember>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsIncentiveAdminGetPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanPopulationPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetPlanPopulationPlans.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`;
    return this.httpClient.request<PageOfMember>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlanRecordsPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetPlanRecordsPlans.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<PageOfRecord>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminGetPlanSettings(
    requestParameters?: SeasonsIncentiveAdminGetPlanSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error(
        'Required parameter planId was null or undefined when calling seasonsIncentiveAdminGetPlanSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<PlanSettingsModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminGetPlans(
    requestParameters?: SeasonsIncentiveAdminGetPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminGetPlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PlanModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminGetPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetPublicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetPublicationSettings.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetPublicationSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PublicationSettingsModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetRecords(
    requestParameters?: SeasonsIncentiveAdminGetRecordsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetRecords.'
      );
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId2 = requestParameters?.seasonId2;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PageOfRecord>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettings>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminGetSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonCommunicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetSeasonCommunicationSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettings>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeeSeasonOverview>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeeSeasonOverview>>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeeSeasonOverview>>;
  public seasonsIncentiveAdminGetSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminGetSeasonOverviewForEmployeeMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/overview`;
    return this.httpClient.request<EmployeeSeasonOverview>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfRecord>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfRecord>>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfRecord>>;
  public seasonsIncentiveAdminGetSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonRecordsSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetSeasonRecordsSeasons.'
      );
    }
    const queryId = requestParameters?.queryId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstName = requestParameters?.queryFirstName;
    const queryLastName = requestParameters?.queryLastName;
    const queryCountry = requestParameters?.queryCountry;
    const queryAre = requestParameters?.queryAre;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryState = requestParameters?.queryState;
    const queryPlanName = requestParameters?.queryPlanName;
    const queryStartDate = requestParameters?.queryStartDate;
    const queryEndDate = requestParameters?.queryEndDate;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryLetterType = requestParameters?.queryLetterType;
    const queryProcessStates = requestParameters?.queryProcessStates;
    const queryRecordCommunicationStates = requestParameters?.queryRecordCommunicationStates;
    const queryWorkflow = requestParameters?.queryWorkflow;
    const queryTemplate = requestParameters?.queryTemplate;
    const queryIsDesignReady = requestParameters?.queryIsDesignReady;
    const queryPayoutDate = requestParameters?.queryPayoutDate;
    const queryPayoutState = requestParameters?.queryPayoutState;
    const queryLineManagerName = requestParameters?.queryLineManagerName;
    const queryLineManagerGid = requestParameters?.queryLineManagerGid;
    const querySeasonId = requestParameters?.querySeasonId;
    const queryWorkflowInstanceState = requestParameters?.queryWorkflowInstanceState;
    const queryMultiplier = requestParameters?.queryMultiplier;
    const queryOverallTargetAchievement = requestParameters?.queryOverallTargetAchievement;
    const queryPayoutAmount = requestParameters?.queryPayoutAmount;
    const queryPayoutCurrency = requestParameters?.queryPayoutCurrency;
    const queryIppAchievementValue = requestParameters?.queryIppAchievementValue;
    const queryIncentivePaymentType = requestParameters?.queryIncentivePaymentType;
    const queryContractStatus = requestParameters?.queryContractStatus;
    const queryMeasurementDate = requestParameters?.queryMeasurementDate;
    const queryMeritTitle = requestParameters?.queryMeritTitle;
    const queryEquityTitle = requestParameters?.queryEquityTitle;
    const queryEquitySubTitle = requestParameters?.queryEquitySubTitle;
    const queryManuallyChanged = requestParameters?.queryManuallyChanged;
    const queryNewHire = requestParameters?.queryNewHire;
    const queryPromotion = requestParameters?.queryPromotion;
    const queryTermination = requestParameters?.queryTermination;
    const queryPopulationChange = requestParameters?.queryPopulationChange;
    const queryLineManagerFirstName = requestParameters?.queryLineManagerFirstName;
    const queryLineManagerLastName = requestParameters?.queryLineManagerLastName;
    const queryCompanyManagerFirstName = requestParameters?.queryCompanyManagerFirstName;
    const queryCompanyManagerGid = requestParameters?.queryCompanyManagerGid;
    const queryCompanyManagerLastName = requestParameters?.queryCompanyManagerLastName;
    const queryTemplateName = requestParameters?.queryTemplateName;
    const queryWorkflowType = requestParameters?.queryWorkflowType;
    const queryAutoApprove = requestParameters?.queryAutoApprove;
    const queryApprovalRequired = requestParameters?.queryApprovalRequired;
    const queryLetterState = requestParameters?.queryLetterState;
    const queryProcessState = requestParameters?.queryProcessState;
    const queryExportState = requestParameters?.queryExportState;
    const queryPayrollState = requestParameters?.queryPayrollState;
    const queryMeritRelevancy = requestParameters?.queryMeritRelevancy;
    const queryApprovedByCompanyManager = requestParameters?.queryApprovedByCompanyManager;
    const queryAllocationWorkflowType = requestParameters?.queryAllocationWorkflowType;
    const queryReadyToPayroll = requestParameters?.queryReadyToPayroll;
    const queryEquityRelevancy = requestParameters?.queryEquityRelevancy;
    const queryHasOtpIncrease = requestParameters?.queryHasOtpIncrease;
    const queryIsOtpOnly = requestParameters?.queryIsOtpOnly;
    const queryPlanTitle = requestParameters?.queryPlanTitle;
    const queryLocalCurrency = requestParameters?.queryLocalCurrency;
    const queryProposalAmount = requestParameters?.queryProposalAmount;
    const queryProposalAmountInEuro = requestParameters?.queryProposalAmountInEuro;
    const queryProposalDate = requestParameters?.queryProposalDate;
    const queryProposalState = requestParameters?.queryProposalState;
    const querySpecialPaymentReason = requestParameters?.querySpecialPaymentReason;
    const querySpecialPaymentCompensationType = requestParameters?.querySpecialPaymentCompensationType;
    const queryTemplateLetterName = requestParameters?.queryTemplateLetterName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryId) {
      queryId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Id');
      });
    }
    if (queryGid) {
      queryGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gid');
      });
    }
    if (queryFirstName) {
      queryFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.FirstName');
      });
    }
    if (queryLastName) {
      queryLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LastName');
      });
    }
    if (queryCountry) {
      queryCountry.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Country');
      });
    }
    if (queryAre) {
      queryAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Are');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgClusterNodeName) {
      queryOrgClusterNodeName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgClusterNodeName'
        );
      });
    }
    if (queryState) {
      queryState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.State');
      });
    }
    if (queryPlanName) {
      queryPlanName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanName');
      });
    }
    if (queryStartDate !== undefined && queryStartDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryStartDate, 'Query.StartDate');
    }
    if (queryEndDate !== undefined && queryEndDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryEndDate, 'Query.EndDate');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryLetterType !== undefined && queryLetterType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLetterType, 'Query.LetterType');
    }
    if (queryProcessStates) {
      queryProcessStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessStates');
      });
    }
    if (queryRecordCommunicationStates) {
      queryRecordCommunicationStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.RecordCommunicationStates'
        );
      });
    }
    if (queryWorkflow) {
      queryWorkflow.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Workflow');
      });
    }
    if (queryTemplate) {
      queryTemplate.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Template');
      });
    }
    if (queryIsDesignReady !== undefined && queryIsDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsDesignReady,
        'Query.IsDesignReady'
      );
    }
    if (queryPayoutDate !== undefined && queryPayoutDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPayoutDate, 'Query.PayoutDate');
    }
    if (queryPayoutState) {
      queryPayoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutState');
      });
    }
    if (queryLineManagerName !== undefined && queryLineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLineManagerName,
        'Query.LineManagerName'
      );
    }
    if (queryLineManagerGid) {
      queryLineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LineManagerGid');
      });
    }
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryWorkflowInstanceState) {
      queryWorkflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.WorkflowInstanceState'
        );
      });
    }
    if (queryMultiplier !== undefined && queryMultiplier !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryMultiplier, 'Query.Multiplier');
    }
    if (queryOverallTargetAchievement !== undefined && queryOverallTargetAchievement !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOverallTargetAchievement,
        'Query.OverallTargetAchievement'
      );
    }
    if (queryPayoutAmount !== undefined && queryPayoutAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPayoutAmount,
        'Query.PayoutAmount'
      );
    }
    if (queryPayoutCurrency) {
      queryPayoutCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutCurrency');
      });
    }
    if (queryIppAchievementValue !== undefined && queryIppAchievementValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIppAchievementValue,
        'Query.IppAchievementValue'
      );
    }
    if (queryIncentivePaymentType) {
      queryIncentivePaymentType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncentivePaymentType'
        );
      });
    }
    if (queryContractStatus) {
      queryContractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ContractStatus');
      });
    }
    if (queryMeasurementDate !== undefined && queryMeasurementDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryMeasurementDate,
        'Query.MeasurementDate'
      );
    }
    if (queryMeritTitle) {
      queryMeritTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritTitle');
      });
    }
    if (queryEquityTitle) {
      queryEquityTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityTitle');
      });
    }
    if (queryEquitySubTitle) {
      queryEquitySubTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquitySubTitle');
      });
    }
    if (queryManuallyChanged) {
      queryManuallyChanged.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ManuallyChanged');
      });
    }
    if (queryNewHire) {
      queryNewHire.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHire');
      });
    }
    if (queryPromotion) {
      queryPromotion.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Promotion');
      });
    }
    if (queryTermination) {
      queryTermination.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Termination');
      });
    }
    if (queryPopulationChange) {
      queryPopulationChange.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PopulationChange');
      });
    }
    if (queryLineManagerFirstName) {
      queryLineManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerFirstName'
        );
      });
    }
    if (queryLineManagerLastName) {
      queryLineManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerLastName'
        );
      });
    }
    if (queryCompanyManagerFirstName) {
      queryCompanyManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerFirstName'
        );
      });
    }
    if (queryCompanyManagerGid) {
      queryCompanyManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerGid'
        );
      });
    }
    if (queryCompanyManagerLastName) {
      queryCompanyManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerLastName'
        );
      });
    }
    if (queryTemplateName) {
      queryTemplateName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TemplateName');
      });
    }
    if (queryWorkflowType) {
      queryWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WorkflowType');
      });
    }
    if (queryAutoApprove !== undefined && queryAutoApprove !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAutoApprove,
        'Query.AutoApprove'
      );
    }
    if (queryApprovalRequired !== undefined && queryApprovalRequired !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovalRequired,
        'Query.ApprovalRequired'
      );
    }
    if (queryLetterState) {
      queryLetterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LetterState');
      });
    }
    if (queryProcessState) {
      queryProcessState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessState');
      });
    }
    if (queryExportState) {
      queryExportState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ExportState');
      });
    }
    if (queryPayrollState) {
      queryPayrollState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayrollState');
      });
    }
    if (queryMeritRelevancy) {
      queryMeritRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritRelevancy');
      });
    }
    if (queryApprovedByCompanyManager !== undefined && queryApprovedByCompanyManager !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovedByCompanyManager,
        'Query.ApprovedByCompanyManager'
      );
    }
    if (queryAllocationWorkflowType) {
      queryAllocationWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.AllocationWorkflowType'
        );
      });
    }
    if (queryReadyToPayroll !== undefined && queryReadyToPayroll !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryReadyToPayroll,
        'Query.ReadyToPayroll'
      );
    }
    if (queryEquityRelevancy) {
      queryEquityRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityRelevancy');
      });
    }
    if (queryHasOtpIncrease !== undefined && queryHasOtpIncrease !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHasOtpIncrease,
        'Query.HasOtpIncrease'
      );
    }
    if (queryIsOtpOnly !== undefined && queryIsOtpOnly !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsOtpOnly, 'Query.IsOtpOnly');
    }
    if (queryPlanTitle) {
      queryPlanTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanTitle');
      });
    }
    if (queryLocalCurrency) {
      queryLocalCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LocalCurrency');
      });
    }
    if (queryProposalAmount !== undefined && queryProposalAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmount,
        'Query.ProposalAmount'
      );
    }
    if (queryProposalAmountInEuro !== undefined && queryProposalAmountInEuro !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmountInEuro,
        'Query.ProposalAmountInEuro'
      );
    }
    if (queryProposalDate !== undefined && queryProposalDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalDate,
        'Query.ProposalDate'
      );
    }
    if (queryProposalState) {
      queryProposalState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProposalState');
      });
    }
    if (querySpecialPaymentReason) {
      querySpecialPaymentReason.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentReason'
        );
      });
    }
    if (querySpecialPaymentCompensationType) {
      querySpecialPaymentCompensationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentCompensationType'
        );
      });
    }
    if (queryTemplateLetterName) {
      queryTemplateLetterName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.TemplateLetterName'
        );
      });
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<PageOfRecord>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonSettingsModel>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsIncentiveAdminGetSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminGetSeasonSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetSeasonSettings.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonSettingsModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminGetSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminGetSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminGetSimulation(
    requestParameters?: SeasonsIncentiveAdminGetSimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminGetSimulation.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<Array<PositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Snapshot>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Snapshot>>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Snapshot>>;
  public seasonsIncentiveAdminGetSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminGetSnapshotSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminGetSnapshotSeasons.'
      );
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling seasonsIncentiveAdminGetSnapshotSeasons.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<Snapshot>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<OrganisationSnapshotTreeItem>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<OrganisationSnapshotTreeItem>>>;
  public seasonsIncentiveAdminGetTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminGetTreeOrganisationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminGetTreeOrganisationSnapshots.'
      );
    }
    const parentOrgCode = requestParameters?.parentOrgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (parentOrgCode !== undefined && parentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentOrgCode, 'parentOrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`;
    return this.httpClient.request<Array<OrganisationSnapshotTreeItem>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminPartialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminPartialUpdateEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error(
        'Required parameter snapshotId was null or undefined when calling seasonsIncentiveAdminPartialUpdateEmployeeSnapshots.'
      );
    }
    const updateEmployeeSnapshotPartial = requestParameters?.updateEmployeeSnapshotPartial;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<EmployeeSnapshotsEmployeeSnapshot>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateEmployeeSnapshotPartial,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPrePublishSimulationPublicationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminPrePublishSimulationPublications.'
      );
    }
    const positionName = requestParameters?.positionName;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const positionClass = requestParameters?.positionClass;
    const newPositionClass = requestParameters?.newPositionClass;
    const originalProposedPositionClass = requestParameters?.originalProposedPositionClass;
    const positionType = requestParameters?.positionType;
    const countryIsoCode = requestParameters?.countryIsoCode;
    const incumbentGid = requestParameters?.incumbentGid;
    const incumbentFirstName = requestParameters?.incumbentFirstName;
    const incumbentLastName = requestParameters?.incumbentLastName;
    const incumbentCountryPlaceOfAction = requestParameters?.incumbentCountryPlaceOfAction;
    const validationManagerId = requestParameters?.validationManagerId;
    const validationManagerGid = requestParameters?.validationManagerGid;
    const validationManagerFirstName = requestParameters?.validationManagerFirstName;
    const validationManagerLastName = requestParameters?.validationManagerLastName;
    const validationState = requestParameters?.validationState;
    const placementState = requestParameters?.placementState;
    const newHireState = requestParameters?.newHireState;
    const isLocked = requestParameters?.isLocked;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const incumbentAre = requestParameters?.incumbentAre;
    const tag = requestParameters?.tag;
    const wasPromoted = requestParameters?.wasPromoted;
    const isTransferred = requestParameters?.isTransferred;
    const simulationPublicationsPublishSimulation = requestParameters?.simulationPublicationsPublishSimulation;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (positionName) {
      positionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionName');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (newPositionClass) {
      newPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewPositionClass');
      });
    }
    if (originalProposedPositionClass) {
      originalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'OriginalProposedPositionClass'
        );
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (countryIsoCode) {
      countryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryIsoCode');
      });
    }
    if (incumbentGid) {
      incumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentGid');
      });
    }
    if (incumbentFirstName) {
      incumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentFirstName');
      });
    }
    if (incumbentLastName) {
      incumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentLastName');
      });
    }
    if (incumbentCountryPlaceOfAction) {
      incumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (validationManagerId) {
      validationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerId');
      });
    }
    if (validationManagerGid) {
      validationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerGid');
      });
    }
    if (validationManagerFirstName) {
      validationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerFirstName'
        );
      });
    }
    if (validationManagerLastName) {
      validationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerLastName'
        );
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (placementState) {
      placementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlacementState');
      });
    }
    if (newHireState) {
      newHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewHireState');
      });
    }
    if (isLocked) {
      isLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsLocked');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (incumbentAre) {
      incumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentAre');
      });
    }
    if (tag) {
      tag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Tag');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }
    if (isTransferred) {
      isTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: simulationPublicationsPublishSimulation,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminPublishSimulationPublicationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminPublishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const simulationPublicationsPublishSimulation = requestParameters?.simulationPublicationsPublishSimulation;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: simulationPublicationsPublishSimulation,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<CandidatePoolModel>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<CandidatePoolModel>>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<CandidatePoolModel>>>;
  public seasonsIncentiveAdminQueryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminQueryCandidatePoolsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools`;
    return this.httpClient.request<Array<CandidatePoolModel>>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPositionEvaluationCandidate>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPositionEvaluationCandidate>>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPositionEvaluationCandidate>>;
  public seasonsIncentiveAdminQueryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeCandidatesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates`;
    return this.httpClient.request<PageOfPositionEvaluationCandidate>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfEmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfEmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminQueryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<PageOfEmployeeSnapshotsEmployeeSnapshot>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesEmployeeCandidatesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const seasonId = requestParameters?.seasonId;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const gid = requestParameters?.gid;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const pAOrgCode = requestParameters?.pAOrgCode;
    const candidatePoolTitle = requestParameters?.candidatePoolTitle;
    const orgCode = requestParameters?.orgCode;
    const gender = requestParameters?.gender;
    const orgLevel = requestParameters?.orgLevel;
    const mercerPositionClass = requestParameters?.mercerPositionClass;
    const isPlaced = requestParameters?.isPlaced;
    const isShortlisted = requestParameters?.isShortlisted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (pAOrgCode) {
      pAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PAOrgCode');
      });
    }
    if (candidatePoolTitle) {
      candidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CandidatePoolTitle');
      });
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (gender) {
      gender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gender');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (mercerPositionClass) {
      mercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerPositionClass');
      });
    }
    if (isPlaced !== undefined && isPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaced, 'IsPlaced');
    }
    if (isShortlisted !== undefined && isShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isShortlisted, 'IsShortlisted');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates/field-values`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesOrganisationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminQueryFieldValuesOrganisationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfString>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfString>>;
  public seasonsIncentiveAdminQueryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminQueryFieldValuesRecordsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling seasonsIncentiveAdminQueryFieldValuesRecords.'
      );
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId = requestParameters?.seasonId;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/field-values`;
    return this.httpClient.request<PageOfString>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfOrganisationInformationSnapshot>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfOrganisationInformationSnapshot>>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfOrganisationInformationSnapshot>>;
  public seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryInformationOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminQueryInformationOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<PageOfOrganisationInformationSnapshot>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfMeritInformationVisibilitySettings>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfMeritInformationVisibilitySettings>>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfMeritInformationVisibilitySettings>>;
  public seasonsIncentiveAdminQueryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminQueryInformationVisibilitySettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminQueryInformationVisibilitySettings.'
      );
    }
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryTargetTypeString = requestParameters?.queryTargetTypeString;
    const querySimulationId = requestParameters?.querySimulationId;
    const queryPriority = requestParameters?.queryPriority;
    const queryTitle = requestParameters?.queryTitle;
    const queryAffectedCount = requestParameters?.queryAffectedCount;
    const queryType = requestParameters?.queryType;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryTargetTypeString !== undefined && queryTargetTypeString !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetTypeString,
        'Query.TargetTypeString'
      );
    }
    if (querySimulationId !== undefined && querySimulationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>querySimulationId,
        'Query.SimulationId'
      );
    }
    if (queryPriority !== undefined && queryPriority !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPriority, 'Query.Priority');
    }
    if (queryTitle !== undefined && queryTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryTitle, 'Query.Title');
    }
    if (queryAffectedCount !== undefined && queryAffectedCount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAffectedCount,
        'Query.AffectedCount'
      );
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'Query.Type');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<PageOfMeritInformationVisibilitySettings>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfMember>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfMember>>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfMember>>;
  public seasonsIncentiveAdminQueryMembers(
    requestParameters?: SeasonsIncentiveAdminQueryMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<PageOfMember>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfOrganisationSnapshot>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfOrganisationSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfOrganisationSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminQueryOrganisationSnapshots.'
      );
    }
    const querySeasonId = requestParameters?.querySeasonId;
    const queryOrganisationId = requestParameters?.queryOrganisationId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryParentOrgCode = requestParameters?.queryParentOrgCode;
    const queryHeadId = requestParameters?.queryHeadId;
    const queryHeadGid = requestParameters?.queryHeadGid;
    const queryHeadName = requestParameters?.queryHeadName;
    const queryPositionName = requestParameters?.queryPositionName;
    const queryAdditionalLineOne = requestParameters?.queryAdditionalLineOne;
    const queryAdditionalLineTwo = requestParameters?.queryAdditionalLineTwo;
    const queryAdditionalLineThree = requestParameters?.queryAdditionalLineThree;
    const queryAdditionalLineFour = requestParameters?.queryAdditionalLineFour;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryOrgType = requestParameters?.queryOrgType;
    const queryOrgLevelA = requestParameters?.queryOrgLevelA;
    const queryOrgLevelB = requestParameters?.queryOrgLevelB;
    const queryOrgLevelC = requestParameters?.queryOrgLevelC;
    const queryOrgLevelD = requestParameters?.queryOrgLevelD;
    const queryNumberOfEmployees = requestParameters?.queryNumberOfEmployees;
    const queryHeadFirstname = requestParameters?.queryHeadFirstname;
    const queryHeadLastname = requestParameters?.queryHeadLastname;
    const queryHeadPAOrgCode = requestParameters?.queryHeadPAOrgCode;
    const queryHeadPlaceOfAction = requestParameters?.queryHeadPlaceOfAction;
    const queryHeadMercerJobCode = requestParameters?.queryHeadMercerJobCode;
    const queryHeadMercerPositionClass = requestParameters?.queryHeadMercerPositionClass;
    const queryHeadManagementGroup = requestParameters?.queryHeadManagementGroup;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryRevenue = requestParameters?.queryRevenue;
    const queryHeadCount = requestParameters?.queryHeadCount;
    const queryRevenueOrgSize = requestParameters?.queryRevenueOrgSize;
    const queryHeadCountOrgSize = requestParameters?.queryHeadCountOrgSize;
    const queryShowOrganisationsWithoutOrgInfos = requestParameters?.queryShowOrganisationsWithoutOrgInfos;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryOrganisationId !== undefined && queryOrganisationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrganisationId,
        'Query.OrganisationId'
      );
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgLevel !== undefined && queryOrgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevel, 'Query.OrgLevel');
    }
    if (queryParentOrgCode !== undefined && queryParentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryParentOrgCode,
        'Query.ParentOrgCode'
      );
    }
    if (queryHeadId !== undefined && queryHeadId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadId, 'Query.HeadId');
    }
    if (queryHeadGid !== undefined && queryHeadGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadGid, 'Query.HeadGid');
    }
    if (queryHeadName !== undefined && queryHeadName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadName, 'Query.HeadName');
    }
    if (queryPositionName !== undefined && queryPositionName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPositionName,
        'Query.PositionName'
      );
    }
    if (queryAdditionalLineOne !== undefined && queryAdditionalLineOne !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineOne,
        'Query.AdditionalLineOne'
      );
    }
    if (queryAdditionalLineTwo !== undefined && queryAdditionalLineTwo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineTwo,
        'Query.AdditionalLineTwo'
      );
    }
    if (queryAdditionalLineThree !== undefined && queryAdditionalLineThree !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineThree,
        'Query.AdditionalLineThree'
      );
    }
    if (queryAdditionalLineFour !== undefined && queryAdditionalLineFour !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineFour,
        'Query.AdditionalLineFour'
      );
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryOrgType !== undefined && queryOrgType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgType, 'Query.OrgType');
    }
    if (queryOrgLevelA !== undefined && queryOrgLevelA !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelA, 'Query.OrgLevelA');
    }
    if (queryOrgLevelB !== undefined && queryOrgLevelB !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelB, 'Query.OrgLevelB');
    }
    if (queryOrgLevelC !== undefined && queryOrgLevelC !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelC, 'Query.OrgLevelC');
    }
    if (queryOrgLevelD !== undefined && queryOrgLevelD !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelD, 'Query.OrgLevelD');
    }
    if (queryNumberOfEmployees !== undefined && queryNumberOfEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryNumberOfEmployees,
        'Query.NumberOfEmployees'
      );
    }
    if (queryHeadFirstname !== undefined && queryHeadFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadFirstname,
        'Query.HeadFirstname'
      );
    }
    if (queryHeadLastname !== undefined && queryHeadLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadLastname,
        'Query.HeadLastname'
      );
    }
    if (queryHeadPAOrgCode !== undefined && queryHeadPAOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPAOrgCode,
        'Query.HeadPAOrgCode'
      );
    }
    if (queryHeadPlaceOfAction !== undefined && queryHeadPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPlaceOfAction,
        'Query.HeadPlaceOfAction'
      );
    }
    if (queryHeadMercerJobCode !== undefined && queryHeadMercerJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerJobCode,
        'Query.HeadMercerJobCode'
      );
    }
    if (queryHeadMercerPositionClass !== undefined && queryHeadMercerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerPositionClass,
        'Query.HeadMercerPositionClass'
      );
    }
    if (queryHeadManagementGroup !== undefined && queryHeadManagementGroup !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadManagementGroup,
        'Query.HeadManagementGroup'
      );
    }
    if (queryOrgSize !== undefined && queryOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgSize, 'Query.OrgSize');
    }
    if (queryRevenue !== undefined && queryRevenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryRevenue, 'Query.Revenue');
    }
    if (queryHeadCount !== undefined && queryHeadCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadCount, 'Query.HeadCount');
    }
    if (queryRevenueOrgSize !== undefined && queryRevenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRevenueOrgSize,
        'Query.RevenueOrgSize'
      );
    }
    if (queryHeadCountOrgSize !== undefined && queryHeadCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadCountOrgSize,
        'Query.HeadCountOrgSize'
      );
    }
    if (queryShowOrganisationsWithoutOrgInfos !== undefined && queryShowOrganisationsWithoutOrgInfos !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryShowOrganisationsWithoutOrgInfos,
        'Query.ShowOrganisationsWithoutOrgInfos'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`;
    return this.httpClient.request<PageOfOrganisationSnapshot>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfSnapshot>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfSnapshot>>;
  public seasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const meritSeasonId = requestParameters?.meritSeasonId;
    const search = requestParameters?.search;
    const directs = requestParameters?.directs;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const impersonatedEmployee = requestParameters?.impersonatedEmployee;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (meritSeasonId !== undefined && meritSeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>meritSeasonId, 'MeritSeasonId');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (directs !== undefined && directs !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>directs, 'Directs');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (impersonatedEmployee !== undefined && impersonatedEmployee !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>impersonatedEmployee,
        'impersonatedEmployee'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/snapshots/employees`;
    return this.httpClient.request<PageOfSnapshot>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<OrganisationSnapshotModel>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<OrganisationSnapshotModel>>;
  public seasonsIncentiveAdminQueryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminQueryParentsOrganisationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminQueryParentsOrganisationSnapshots.'
      );
    }
    const seasonId2 = requestParameters?.seasonId2;
    if (seasonId2 === null || seasonId2 === undefined) {
      throw new Error(
        'Required parameter seasonId2 was null or undefined when calling seasonsIncentiveAdminQueryParentsOrganisationSnapshots.'
      );
    }
    const queryOrgCode = requestParameters?.queryOrgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`;
    return this.httpClient.request<OrganisationSnapshotModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPlanWithMissingIndividualValues>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPlanWithMissingIndividualValues>>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPlanWithMissingIndividualValues>>;
  public seasonsIncentiveAdminQueryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminQueryPlanWithMissingIndividualValuesParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryKpiId = requestParameters?.queryKpiId;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryGid = requestParameters?.queryGid;
    const queryLastname = requestParameters?.queryLastname;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryCountry = requestParameters?.queryCountry;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryRecordStartdate = requestParameters?.queryRecordStartdate;
    const queryPlanName = requestParameters?.queryPlanName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryKpiId !== undefined && queryKpiId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryKpiId, 'Query.KpiId');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryOrgClusterNodeName !== undefined && queryOrgClusterNodeName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrgClusterNodeName,
        'Query.OrgClusterNodeName'
      );
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryCountry !== undefined && queryCountry !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryCountry, 'Query.Country');
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryRecordStartdate !== undefined && queryRecordStartdate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRecordStartdate,
        'Query.RecordStartdate'
      );
    }
    if (queryPlanName !== undefined && queryPlanName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPlanName, 'Query.PlanName');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/missing-individual-values`;
    return this.httpClient.request<PageOfPlanWithMissingIndividualValues>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfPlan>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfPlan>>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfPlan>>;
  public seasonsIncentiveAdminQueryPlans(
    requestParameters?: SeasonsIncentiveAdminQueryPlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans`;
    return this.httpClient.request<PageOfPlan>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<BucketComponentsPossibilities>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<BucketComponentsPossibilities>>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<BucketComponentsPossibilities>>>;
  public seasonsIncentiveAdminQueryPossibilitiesBudgetBuckets(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/component-settings`;
    return this.httpClient.request<Array<BucketComponentsPossibilities>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfSeason>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfSeason>>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfSeason>>;
  public seasonsIncentiveAdminQuerySeasons(
    requestParameters?: SeasonsIncentiveAdminQuerySeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const seasonType = requestParameters?.seasonType;
    const simulationState = requestParameters?.simulationState;
    const queryManagerEndDateAt = requestParameters?.queryManagerEndDateAt;
    const queryPartnerEndDateAt = requestParameters?.queryPartnerEndDateAt;
    const querySeasonType = requestParameters?.querySeasonType;
    const querySimulationState = requestParameters?.querySimulationState;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (seasonType) {
      seasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SeasonType');
      });
    }
    if (simulationState) {
      simulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SimulationState');
      });
    }
    if (queryManagerEndDateAt !== undefined && queryManagerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryManagerEndDateAt,
        'Query.ManagerEndDateAt'
      );
    }
    if (queryPartnerEndDateAt !== undefined && queryPartnerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPartnerEndDateAt,
        'Query.PartnerEndDateAt'
      );
    }
    if (querySeasonType) {
      querySeasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SeasonType');
      });
    }
    if (querySimulationState) {
      querySimulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SimulationState');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<PageOfSeason>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationModel>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationModel>>>;
  public seasonsIncentiveAdminQuerySimulation(
    requestParameters?: SeasonsIncentiveAdminQuerySimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminQuerySimulation.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`;
    return this.httpClient.request<Array<PositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateCandidatePools(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/recalculate`;
    return this.httpClient.request<TransactionStatusOfCandidatePoolRecalculationMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const parentSettingId = requestParameters?.parentSettingId;
    if (parentSettingId === null || parentSettingId === undefined) {
      throw new Error(
        'Required parameter parentSettingId was null or undefined when calling seasonsIncentiveAdminRecalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculatePlanPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminRecalculatePlanPopulations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminRecalculateSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSavePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSavePlanPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminSavePlanPopulations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public seasonsIncentiveAdminSaveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSaveSeasonPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminSaveSeasonPopulations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PopulationCreatedResultPagedDto>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulatePlanPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminSimulatePlanPopulations.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const ruleSet = requestParameters?.ruleSet;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<PopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: ruleSet,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PageOfEmployeesEmployeesEmployee>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PageOfEmployeesEmployeesEmployee>>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PageOfEmployeesEmployeesEmployee>>;
  public seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminSimulateRuleInformationVisibilitySettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminSimulateRuleInformationVisibilitySettings.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const ruleSet = requestParameters?.ruleSet;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<PageOfEmployeesEmployeesEmployee>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: ruleSet,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeePopulationCreatedResultPagedDto>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeePopulationCreatedResultPagedDto>>;
  public seasonsIncentiveAdminSimulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminSimulateSeasonPopulationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminSimulateSeasonPopulations.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const _export = requestParameters?._export;
    const ruleSet = requestParameters?.ruleSet;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (_export !== undefined && _export !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>_export, 'export');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<EmployeePopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: ruleSet,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPrePublishSimulationPublicationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminUnPrePublishSimulationPublications.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public seasonsIncentiveAdminUnPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminUnPublishSimulationPublicationsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminUnPublishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const unPublishSimulation = requestParameters?.unPublishSimulation;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: unPublishSimulation,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public seasonsIncentiveAdminUpdateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateBenchmarkValuesSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const updateSnapshotBenchmarkValues = requestParameters?.updateSnapshotBenchmarkValues;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/snapshots/benchmarks`;
    return this.httpClient.request<TransactionStatusOfImportStatusMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateSnapshotBenchmarkValues,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling seasonsIncentiveAdminUpdateBucketComponentBatchBudgetComponents.'
      );
    }
    const updateManyBucketComponents = requestParameters?.updateManyBucketComponents;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<BucketComponentModificationResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateManyBucketComponents,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BucketComponentModificationResponse>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BucketComponentModificationResponse>>;
  public seasonsIncentiveAdminUpdateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminUpdateBucketComponentBudgetComponentsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling seasonsIncentiveAdminUpdateBucketComponentBudgetComponents.'
      );
    }
    const updateBucketComponent = requestParameters?.updateBucketComponent;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<BucketComponentModificationResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateBucketComponent,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateBudgetBucketsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminUpdateBudgetBuckets.'
      );
    }
    const updateBudgetBucket = requestParameters?.updateBudgetBucket;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<BudgetBucketModificationResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateBudgetBucket,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<CandidatePoolModel>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<CandidatePoolModel>>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<CandidatePoolModel>>;
  public seasonsIncentiveAdminUpdateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminUpdateCandidatePoolsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminUpdateCandidatePools.'
      );
    }
    const updateCandidatePool = requestParameters?.updateCandidatePool;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<CandidatePoolModel>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateCandidatePool,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeeSnapshotsEmployeeSnapshot>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeeSnapshotsEmployeeSnapshot>>;
  public seasonsIncentiveAdminUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateEmployeeSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const updateEmployeeSnapshot = requestParameters?.updateEmployeeSnapshot;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<EmployeeSnapshotsEmployeeSnapshot>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateEmployeeSnapshot,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsModel>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsModel>>;
  public seasonsIncentiveAdminUpdateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminUpdateInformationVisibilitySettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling seasonsIncentiveAdminUpdateInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminUpdateInformationVisibilitySettings.'
      );
    }
    const updateInformationVisibilitySettings = requestParameters?.updateInformationVisibilitySettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<MeritInformationVisibilitySettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateInformationVisibilitySettings,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<BudgetBucketModificationResponse>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<BudgetBucketModificationResponse>>;
  public seasonsIncentiveAdminUpdateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminUpdateManyBudgetBucketsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const updateManyBudgetBuckets = requestParameters?.updateManyBudgetBuckets;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/batch`;
    return this.httpClient.request<BudgetBucketModificationResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateManyBudgetBuckets,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MemberModel>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MemberModel>>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MemberModel>>;
  public seasonsIncentiveAdminUpdateMembers(
    requestParameters?: SeasonsIncentiveAdminUpdateMembersParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const updateMember = requestParameters?.updateMember;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<MemberModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateMember,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<OrganisationInformationSnapshotModel>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<OrganisationInformationSnapshotModel>>;
  public seasonsIncentiveAdminUpdateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminUpdateOrganisationInformationSnapshotsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminUpdateOrganisationInformationSnapshots.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminUpdateOrganisationInformationSnapshots.'
      );
    }
    const updateOrganisationInformationSnapshot = requestParameters?.updateOrganisationInformationSnapshot;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<OrganisationInformationSnapshotModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateOrganisationInformationSnapshot,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanSettingsModel>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanSettingsModel>>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanSettingsModel>>;
  public seasonsIncentiveAdminUpdatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePlanSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling seasonsIncentiveAdminUpdatePlanSettings.'
      );
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error(
        'Required parameter planId was null or undefined when calling seasonsIncentiveAdminUpdatePlanSettings.'
      );
    }
    const updatePlanSettings = requestParameters?.updatePlanSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PlanSettingsModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePlanSettings,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PlanModel>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PlanModel>>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PlanModel>>;
  public seasonsIncentiveAdminUpdatePlans(
    requestParameters?: SeasonsIncentiveAdminUpdatePlansParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling seasonsIncentiveAdminUpdatePlans.');
    }
    const updatePlan = requestParameters?.updatePlan;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<PlanModel>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePlan,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<PublicationSettingsModel>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<PublicationSettingsModel>>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<PublicationSettingsModel>>;
  public seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdatePublicationSettingsPublicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminUpdatePublicationSettingsPublicationSettings.'
      );
    }
    const updatePublicationSettings = requestParameters?.updatePublicationSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<PublicationSettingsModel>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updatePublicationSettings,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettings>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettings>>;
  public seasonsIncentiveAdminUpdateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonCommunicationSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminUpdateSeasonCommunicationSettings.'
      );
    }
    const updateCommunicationSettings = requestParameters?.updateCommunicationSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettings>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateCommunicationSettings,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonSettingsModel>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonSettingsModel>>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonSettingsModel>>;
  public seasonsIncentiveAdminUpdateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonSettingsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const setSeasonSettings = requestParameters?.setSeasonSettings;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/settings`;
    return this.httpClient.request<SeasonSettingsModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: setSeasonSettings,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonModel>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonModel>>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonModel>>;
  public seasonsIncentiveAdminUpdateSeasons(
    requestParameters?: SeasonsIncentiveAdminUpdateSeasonsParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const updateSeason = requestParameters?.updateSeason;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<SeasonModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateSeason,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSimulationsSimulation>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSimulationsSimulation>>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSimulationsSimulation>>;
  public seasonsIncentiveAdminUpdateSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminUpdateSimulation.'
      );
    }
    const seasonsSimulationsUpdateSimulation = requestParameters?.seasonsSimulationsUpdateSimulation;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSimulationsSimulation>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsUpdateSimulation,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public seasonsIncentiveAdminUpdateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminUpdateSimulationMembersSimulationParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling seasonsIncentiveAdminUpdateSimulationMembersSimulation.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling seasonsIncentiveAdminUpdateSimulationMembersSimulation.'
      );
    }
    const updateSimulationMembers = requestParameters?.updateSimulationMembers;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: updateSimulationMembers,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
